import { UserRelation } from './auth';
import { Nullable } from './global';

export interface Preset {
  id: string;
  refId: string;
  type: string;
  name: string;
  value: string;
  user: UserRelation;
  created: string;
  modified: string;
  isMine?: boolean;
  enforceUniqueName?: boolean;
  visibility?: Nullable<PresetVisibility>;
  favorite?: boolean;
  metadata?: string;
  workspace: {
    id: string;
    user: UserRelation;
  };
}

export interface ParsedPreset<T = string> extends Omit<Preset, 'value'> {
  value: T;
}

export type CreatePresetRequest<T = string> = Pick<
  Preset,
  'name' | 'type' | 'favorite' | 'metadata' | 'visibility'
> & {
  value: T;
  allowDuplication?: boolean;
  shareable?: boolean;
  /** When true, the create endpoint returns the existing preset with the same
   *  name (or creates and returns a new one if none exists) instead of erroring
   *  on a duplicate name. Enables idempotent create-or-get in a single request. */
  returnDuplicatedValue?: boolean;
  refId?: string;
};

export type UpdatePresetRequest<T = string> = Pick<Preset, 'metadata'> & {
  value: T;
};

export enum PresetVisibility {
  ALL = '',
  PRIVATE = 'PRIVATE',
  INTERNAL = 'INTERNAL',
  PUBLIC = 'PUBLIC',
}
